import script from "./ShowerHeadDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowerHeadDetails.vue?vue&type=script&setup=true&lang=js"

import "./ShowerHeadDetails.vue?vue&type=style&index=0&id=7104ccf0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7104ccf0"]])

export default __exports__